<ol class="mass-os-stepper" aria-label="Pasos del asistente">
  <li
    *ngFor="let step of steps; let i = index"
    class="mass-os-stepper__item"
    [class.mass-os-stepper__item--active]="i === activeIndex"
    [class.mass-os-stepper__item--done]="i < activeIndex"
  >
    <button
      type="button"
      class="mass-os-stepper__btn"
      [disabled]="i > activeIndex"
      [attr.aria-current]="i === activeIndex ? 'step' : null"
      (click)="select(i)"
    >
      <span class="mass-os-stepper__bullet">
        <mat-icon *ngIf="i < activeIndex" class="mass-os-stepper__check">check</mat-icon>
        <span *ngIf="i >= activeIndex">{{ i + 1 }}</span>
      </span>
      <span class="mass-os-stepper__label">{{ step }}</span>
    </button>

    <span
      class="mass-os-stepper__line"
      *ngIf="i < steps.length - 1"
      aria-hidden="true"
    ></span>
  </li>
</ol>
